import client from "../client";

export interface UpdateMemberBankAccountRequest {
  bank_name?: string;
  bank_type_id?: number;
  bank_number?: string;
  tel?: string;
  token?: string;
  pin?: string;
  prefix: string;
}

export default function API(request: UpdateMemberBankAccountRequest) {
  return client
    .post(`members/update_bank_account`, request)
    .then((response) => response.data);
}
